import type { DateTimeString, Uuid } from "@/utils"

export enum ProductId {
  // Base Products
  Twiddler = "twiddler", // free
  Dabbler = "dabbler",
  Trickster = "trickster",
  Maestro = "maestro",
  // Add-ons
  Concurrency = "concurrency",
  Seat = "seat",
  Enterprise = "enterprise",
}

export type Money = { amount: number; currency: string }

type ProductBase = {
  id: ProductId
  name: string
  tagline: string
  description: string[]
  monthlyPrice: Money
  yearlyPrice: Money
}
type BaseProduct = ProductBase & {
  productType: "base"
  overagePrice?: Money // per 10k, absent from free
  spark?: "purple" | "orange" | "yellow" | null // Only for paid
  successMessage?: string // Only for paid
}
type AddonProduct = ProductBase & {
  productType: "addon"
  isStackable: boolean
  forBases: ProductId[]
}
export type Product = BaseProduct | AddonProduct

export type CartItem = {
  productId: ProductId
  quantity: number
}

export type Cart = {
  items: CartItem[]
  interval: "month" | "year"
}

export type CartRequest = {
  cart: Cart
}

export type CreateCheckoutRequest = CartRequest & {
  colourScheme: "light" | "dark"
}

export type Subscription = {
  id: Uuid
  tenantId: Uuid
  updatedAt: DateTimeString
  provisioned: boolean
  baseProductId: ProductId
  addonItems: CartItem[]
  interval: "month" | "year"
  stripe: boolean
  cancelAt: DateTimeString | null
}
